//import { setHistoryPath } from "common/actions/app-configuration-actions";
//import { appConfigurationStore } from "common/stores/app-configuration-store";
import { observer } from "mobx-react";
import React, { FC, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";

export interface CustomLocationState {
  from?: { pathname: string };
}

interface AuthProps {
  isAuthenticated?: boolean;
}

interface ProtectedRouteProps extends AuthProps {
  component?: React.ComponentType<any>;
  children?: React.ReactNode;
}

export const ProtectedRoute: FC<ProtectedRouteProps> = observer(
  ({
    component: Component,
    children,
    //isAuthenticated,
  }) => {
    const location = useLocation();
    const isAuth = isAuthenticated();

    if (!isAuth) {
      return (
        <Navigate
          to="/auth/login"
          state={{ from: location } as CustomLocationState}
          replace
        />
      );
    }

    if (children) {
      return <>{children}</>;
    }

    if (Component) {
      return <Component />;
    }

    return null;
  }
);

export const UnauthenticatedRoute: FC<ProtectedRouteProps> = ({
  component: Component,
  children,
  //isAuthenticated,
}) => {
  const isAuth = isAuthenticated();

  if (isAuth) {
    return <Navigate to="/" replace />;
  }

  if (children) {
    return <>{children}</>;
  }

  if (Component) {
    return <Component />;
  }

  return null;
};

export const isAuthenticated = () => {
  try {
    const login_data = JSON.parse(localStorage.getItem("login") || "{}");

    if (login_data.token) {
      const currentDate = new Date();
      const expDate = login_data.expiration;
      if (expDate && expDate < currentDate.getTime()) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  } catch {
    return false;
  }
};
